module.exports = __webpack_public_path__ + "../resources/img/ic_re_arrow_right.597eb7bf.svg";